import { render, staticRenderFns } from "./BlacklistFormModal.vue?vue&type=template&id=521b750e&"
import script from "./BlacklistFormModal.vue?vue&type=script&lang=js&"
export * from "./BlacklistFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports